import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-bold text-lg" }
const _hoisted_2 = { class: "image-picker w-full mt-3" }
const _hoisted_3 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_4 = ["accept"]
const _hoisted_5 = { class: "content-images" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = {
  key: 1,
  class: "preview-container w-full"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("main", _hoisted_2, [
      (_ctx.modelValue.length === 0)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)), ["prevent"])),
              accept: _ctx.accept,
              hidden: "",
              multiple: ""
            }, null, 40, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_icon, {
                name: "md-uploadfile-outlined",
                class: "text-h-primary-500",
                scale: 2
              }),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("theme.org.form.imagePicker")), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (src, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "preview"
              }, [
                _createElementVNode("img", {
                  src: _ctx.getFileUrl(src),
                  alt: src.name,
                  class: "object-contain bg-neutral-100 border"
                }, null, 8, _hoisted_8),
                _createElementVNode("button", {
                  text: "",
                  onClick: _withModifiers(($event: any) => (_ctx.removeImage(index)), ["prevent"])
                }, "×", 8, _hoisted_9)
              ]))
            }), 128)),
            (_ctx.modelValue.length < _ctx.maxFiles)
              ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                  _createElementVNode("input", {
                    type: "file",
                    onChange: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)), ["prevent"])),
                    accept: _ctx.accept,
                    hidden: "",
                    multiple: ""
                  }, null, 40, _hoisted_11),
                  _createVNode(_component_v_icon, {
                    name: "md-addcircle",
                    class: "text-h-primary-500 cursor-pointer hover:opacity-75",
                    scale: 2
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 64))
}